import { render } from "./Pagoproveedormodal.vue?vue&type=template&id=1e7f8736&scoped=true"
import script from "./Pagoproveedormodal.vue?vue&type=script&lang=js"
export * from "./Pagoproveedormodal.vue?vue&type=script&lang=js"

import "./Pagoproveedormodal.vue?vue&type=style&index=0&id=1e7f8736&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\frontend.avicola\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1e7f8736"]])

export default __exports__